module.exports = __webpack_public_path__ + "img/Marigold.21319d2d.png";